module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": "Backhaul",
      "icon": "fa fa-wifi",
      "table-ref": "backhaultable",
      "url": '/backhaul/site/' + _vm.rowData.id,
      "hide-org-badge": "",
      "show-search": false,
      "fields": _vm.backhaulFields
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bd8322c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/calendar/Backhaul.vue
// module id = 1444
// module chunks = 0